import { render, staticRenderFns } from "./DetailResult.vue?vue&type=template&id=16c04555&scoped=true&"
import script from "./DetailResult.vue?vue&type=script&lang=js&"
export * from "./DetailResult.vue?vue&type=script&lang=js&"
import style0 from "./DetailResult.vue?vue&type=style&index=0&id=16c04555&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c04555",
  null
  
)

export default component.exports